var map = {
	"./de.json": 298973,
	"./en.json": 960400,
	"./es.json": 165441,
	"./fr.json": 270830,
	"./it.json": 160642,
	"./ja.json": 915941,
	"./ko.json": 183794,
	"./pl.json": 208324,
	"./pt.json": 557726,
	"./ru.json": 310756,
	"./uk.json": 349705
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 939564;